/**
 * Debounce helper for tracking calls driven by continuous controls.
 *
 * A slider fires its setter on every notch, and instrumenting the setter
 * directly would count one drag as a dozen changes. Routing the call through
 * here keeps only the LAST value once the control has been left alone for
 * DEBOUNCE_MS — one drag, one event.
 *
 * Keyed by an arbitrary string so independent controls never debounce each
 * other (two different sliders moved in the same second are two events).
 */
const DEBOUNCE_MS = 1_500;

const timers = new Map<string, ReturnType<typeof setTimeout>>();

export function trackDebounced(key: string, fire: () => void): void {
  const existing = timers.get(key);
  if (existing) clearTimeout(existing);
  timers.set(
    key,
    setTimeout(() => {
      timers.delete(key);
      fire();
    }, DEBOUNCE_MS),
  );
}
